import { isNil } from "lodash";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { ROUTES, schemaRunPath, schemaTestListPath } from "../../route-paths";

/**
 * The routes the retired `/docs?tab=N` hub's tabs became, indexed by the tab
 * number those bookmarks carry.
 */
const DOCS_TAB_ROUTES: readonly string[] = [
  ROUTES.DOC_INGESTION_SCHEMA_EDITOR,
  ROUTES.DOC_INGESTION_SCHEMAS,
  ROUTES.DOC_INGESTION_OUTLOOK_INTEGRATIONS,
  ROUTES.DOC_INGESTION_STATISTICS,
  ROUTES.DOC_INGESTION_LOGS,
];

/**
 * Redirects `/docs` bookmarks to the page that tab became. A bare `/docs`, or
 * a tab number outside the range the hub ever had, lands on the schema editor.
 */
export const DocsTabRedirect = () => {
  const { search } = useLocation();
  const tab = Number.parseInt(new URLSearchParams(search).get("tab") ?? "", 10);
  const target = tab >= 0 ? DOCS_TAB_ROUTES[tab] : undefined;

  return <Navigate replace to={target ?? ROUTES.DOC_INGESTION_SCHEMA_EDITOR} />;
};

/** Redirects `/schema-test-lists/:uuid` bookmarks to the doc-ingestion route. */
export const SchemaTestListRedirect = () => {
  const { uuid } = useParams();

  return isNil(uuid) ? (
    <Navigate replace to={ROUTES.DOC_INGESTION_SCHEMA_TEST_LISTS} />
  ) : (
    <Navigate replace to={schemaTestListPath(uuid)} />
  );
};

/** Redirects `/schema-runs/:uuid` bookmarks to the doc-ingestion route. */
export const SchemaRunRedirect = () => {
  const { uuid } = useParams();

  return isNil(uuid) ? (
    <Navigate replace to={ROUTES.DOC_INGESTION_SCHEMA_TEST_LISTS} />
  ) : (
    <Navigate replace to={schemaRunPath(uuid)} />
  );
};
